const NEWSLETTER_CONTACT_LIST_ID = "41065259";
const MOBILE_VIEW_QUERY_PARAM = "mobwebview";

const NEWSLETTER_MESSAGES = {
  SUCCESS: "குழுவில் இணைந்ததற்கு நன்றி.", // Your subscription is successful.
  UNSUB_SUCCESS: "நீங்கள் சந்தாவிலிருந்து நீக்கப்பட்டுள்ளீர்கள்", // You have been unsubscribed.
  FAILED: "உங்கள் சந்தாவில் ஒரு சிக்கல் உள்ளது.", // There is a problem with your subscription.
  INVALID_EMAIL: "தவறான மின்னஞ்சல் முகவரி", // Invalid email address
};

export {
  MOBILE_VIEW_QUERY_PARAM,
  NEWSLETTER_CONTACT_LIST_ID,
  NEWSLETTER_MESSAGES,
};

// Newsletter Preview constants
export const BASIC_UTM_TAGS = `utm_source=emarsys&utm_medium=email&utm_campaign=tm_newsletter&utm_content=`;
export const APP_STORE_LINK = `https://apps.apple.com/app/apple-store/id6447955016?pt=123719093&ct=TM_Website_Banner&mt=8`;
export const PLAYSTORE_LINK = `https://tamilmurasu.page.link/applaunchWebBanner2023`;
export const TM_WHATSAPP = `https://api.whatsapp.com/send?text=%20https%3A%2F%2Fwww.tamilmurasu.com.sg`;
export const TM_TWITTER = `https://twitter.com/tamilmurasu`;
export const TM_TELEGRAM = `https://t.me/tamilmurasu`;
export const TM_FACEBOOK = `https://www.facebook.com/tamilmurasu`;
export const TM_INSTAGRAM = `https://www.instagram.com/tamil_murasu`;
export const TM_YOUTUBE = `https://www.youtube.com/channel/UCs0xZ60FSNxFxHPVFFsXNTA`;

export const NEWSLETTER_FROM_NAME = "Tamil Murasu";
export const NEWSLETTER_FROM_EMAIL = "postmaster@edm.tamilmurasu.com.sg";
export const LAUNCH_AFTER = 10; // Launch after 10 minutes

// Feature flag: when enabled, the newsletter form submits via the Consent v3
// API (/_plat/api/v1/consent/sync). When disabled, it falls back to the legacy
// newsletterSignup endpoint. Toggle by setting VITE_ENABLE_CONSENT_V3_NEWSLETTER=1.
export const ENABLE_CONSENT_V3_NEWSLETTER =
  import.meta.env.VITE_ENABLE_CONSENT_V3_NEWSLETTER === "1";
